import React, {} from 'react';
import { joinClassNames } from './joinClassNames.js';
const styles = {"stack":"Stack-module__stack__m1iSI","directionColumn":"Stack-module__directionColumn__vH8vU","directionRow":"Stack-module__directionRow__X0bCH","gapNone":"Stack-module__gapNone__43myn","gapSmall":"Stack-module__gapSmall__PlUbO","gapMedium":"Stack-module__gapMedium__NoqVY","gapLarge":"Stack-module__gapLarge__W8Xf7","gapExtraLarge":"Stack-module__gapExtraLarge__ntgJP","alignStart":"Stack-module__alignStart__KLTJv","alignCenter":"Stack-module__alignCenter__ijDyr","alignStretch":"Stack-module__alignStretch__TSZRJ","justifyStart":"Stack-module__justifyStart__zd54E","justifyCenter":"Stack-module__justifyCenter__n7GeA","justifyBetween":"Stack-module__justifyBetween__jlsdy","wrap":"Stack-module__wrap__0OM-f"};
const DIRECTION_CLASS_NAMES = {
    column: styles.directionColumn,
    row: styles.directionRow
};
const GAP_CLASS_NAMES = {
    none: styles.gapNone,
    small: styles.gapSmall,
    medium: styles.gapMedium,
    large: styles.gapLarge,
    extraLarge: styles.gapExtraLarge
};
const ALIGN_CLASS_NAMES = {
    start: styles.alignStart,
    center: styles.alignCenter,
    stretch: styles.alignStretch
};
const JUSTIFY_CLASS_NAMES = {
    start: styles.justifyStart,
    center: styles.justifyCenter,
    between: styles.justifyBetween
};
/** Lays its children out in a column or a row, spaced by a token gap. */
export function Stack({ direction = 'column', gap = 'medium', align = 'stretch', justify = 'start', wrap = false, children }) {
    const className = joinClassNames(styles.stack, DIRECTION_CLASS_NAMES[direction], GAP_CLASS_NAMES[gap], ALIGN_CLASS_NAMES[align], JUSTIFY_CLASS_NAMES[justify], wrap ? styles.wrap : undefined);
    return React.createElement("div", { className: className }, children);
}
//# sourceMappingURL=Stack.js.map